export const onSetDevice = (device) => ({
  type: 'SET_DEVICE',
  device
})

export const onSetFingerprint = (fingerprint) => ({
  type: 'SET_FINGERPRINT',
  fingerprint
})